import { Component, OnInit } from '@angular/core';
import { appMatDialogDefaultConfig, HomepageBaseUrl } from '../../../../../helper/helper';
import { MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { FlutterBridgeService } from '../../../../../flutter-bridge/flutter-bridge-service';

@Component({
    selector: 'app-support-dialog',
    templateUrl: './support-dialog.component.html',
    styleUrls: ['./support-dialog.component.scss'],
})
export class SupportDialogComponent {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
    };

    public HomepageBaseUrl = HomepageBaseUrl;
    constructor() {
    }


}
